<template>
  <div>
    <b-tabs v-model="selectedTab" card>
      <b-card>
        <b-row>
          <b-col class="mb-3">
            <call-filter :id="id"
                         :key="refresh"
                         ref="call_filter"
                         v-model="proposals"
                         @load-data="loadCericProposalsFor"
                         @selected-call-change="callChange"
                         @update-proposals="refreshProposals"/>
          </b-col>
        </b-row>
        <b-card-header class="mb-1 p-0">
          <b-button v-b-modal.modalCericProposal
                    :disabled="!isUserCericEditor"
                    block
                    variant="info"
                    @click="setFocusedId('')"
                    v-text="createProposalBtnText"/>
        </b-card-header>
        <b-tab active
               class="p-0"
               title="Ceric proposals">
          <ceric-manage-table :fields="fields"
                              :is-user-ceric-editor="isUserCericEditor"
                              :proposals="proposals"
                              @update-focused-id="setFocusedId"/>
          <ceric-manage-modal :object-id="focusedId"
                              @refresh-dashboard="refresh = !refresh"/>
        </b-tab>
      </b-card>
    </b-tabs>
  </div>
</template>

<script>
  import callFilter from '@/components/call_filter';
  import CericManageModal from '@/components/proposal/ceric/CericManageModal';
  import CericManageTable from '@/components/proposal/ceric/CericManageTable';

  export default {
    name: 'CericManageDashboard',
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String,
        default: '',
      },
    },
    components: {
      CericManageTable,
      callFilter,
      CericManageModal,
    },
    data() {
      return {
        proposals: [],
        allProposalsForCall: [],
        id: 0,
        selectedTab: 0,
        focusedId: '',
        refresh: true,
        createProposalBtnText: 'Create new CERIC proposal',
      };
    },
    computed: {
      isUserCericEditor() {
        const permissions = this.$store.getters['login/getLoggedUserAttribute']('permissions') || [];
        return permissions.includes('EDIT_PROP_CERIC');
      },
    },
    methods: {
      loadCericProposalsFor(call) {
        this.axios.get(`/documents/ceric/${this.type}/${call}`)
          .then((response) => {
            this.proposals = response.data;
            this.$set(this, 'allProposalsForCall', this.proposals);
            // setup the data in proposal-filter, call-filter component
            this.$emit('setup-proposal', this.proposals);
            // load data from children component
            this.$emit('load-data');
          });
      },
      setFocusedId(objectId) {
        this.focusedId = objectId;
      },
      refreshProposals(proposals) {
        this.refreshProposalsFilter(proposals);
        this.$set(this, 'allProposalsForCall', this.proposals);
      },
    },
    watch: {
      selectedTab() {
        this.$emit('refresh');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    margin: 1.25rem;
  }
</style>
